import type { LabelHTMLAttributes, ReactNode } from 'react';

import { cn } from '../../lib/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
  children: ReactNode;
}

/**
 * Nhãn của một trường biểu mẫu (§9.3.3).
 * Ít dùng trực tiếp — `<Field>` tự vẽ nhãn này.
 */
export function Label({ required, children, className, ...props }: LabelProps) {
  return (
    <label className={cn('block text-sm font-medium text-content-secondary', className)} {...props}>
      {children}
      {required && <span className="ml-0.5 text-danger-600">*</span>}
    </label>
  );
}
